import {useGa4MountEffect} from 'hooks/useGa4MountEffect'
import {useCurrency} from 'providers/EnvironmentProvider'
import {useCrossSelling} from 'providers/OrderDetailsProvider'
import {Ventrata} from 'types'
import {formatMoney} from 'utils/formatMoney'
import {getGa4OrderItems} from 'utils/getGa4OrderItems'
import {getHumanPrice} from 'utils/getHumanPrice'
import {getTotalAmount} from 'utils/getTotalAmount'
import {CartItem} from './CartItem'

type Props = {
  order: Ventrata.Order
}

export const CartItems = ({order}: Props) => {
  const currency = useCurrency()
  const crossSelling = useCrossSelling()

  useGa4MountEffect({
    event: 'view_cart',
    ecommerce: {
      currency,
      value: getHumanPrice(order.pricing?.retail),
      checkout_type: 'custom_checkout',
      items: getGa4OrderItems(order, currency, crossSelling),
    },
  })

  return (
    <div className="flex flex-col gap-4">
      {order.bookings.map((booking) => {
        return <CartItem key={booking.uuid} booking={booking} />
      })}
      <div className="hidden d:flex justify-end font-bold text-lg">
        Total {formatMoney(getTotalAmount(order), order.pricing?.currency)}
      </div>
    </div>
  )
}
